import { useTranslation } from 'react-i18next';
import React, { memo } from 'react';
import cx from 'clsx';

import { IconRcCircleCross } from 'assets/icon/common';

import './index.css';
import { useDeviceTypeIsMobile } from '@/hooks';

type DowngradeType = {
  className?: string;
};

export const Downgrade = memo(({ className, ...rest }: DowngradeType) => {
  const { t } = useTranslation();

  const isMobile = useDeviceTypeIsMobile();
  return (
    <div className={cx('db-downgrade', isMobile && 'db-downgrade-mobile', className)} {...rest}>
      <IconRcCircleCross className="db-downgrade-icon" />
      {t('Downgrade.1itcrq8')}
    </div>
  );
});
